module.exports = __webpack_public_path__ + "img/adv_p2p.f1fa688f.png";